import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { BANNER_SCALING_WHEN_WINDOW_WIDTH_LOWER } from "../..";
import { hexToRgb } from "../../../utils";
var ZINDEX = 999999999;

var BlockerHeroInlineStyles = /*#__PURE__*/function () {
  function BlockerHeroInlineStyles() {
    _classCallCheck(this, BlockerHeroInlineStyles);
  }

  _createClass(BlockerHeroInlineStyles, null, [{
    key: "aspectRatioWrapper",
    value: function aspectRatioWrapper(_ref) {
      var _ref$blocker = _ref.blocker,
          visualContentType = _ref$blocker.visualContentType,
          _ref$blocker$visualTh = _ref$blocker.visualThumbnail,
          width = _ref$blocker$visualTh.width,
          height = _ref$blocker$visualTh.height,
          forceRatio = _ref$blocker$visualTh.forceRatio,
          visualDarkMode = _ref$blocker.visualDarkMode,
          antiAdBlocker = _ref.customCss.antiAdBlocker;
      var style = {
        paddingTop: forceRatio ? "".concat(forceRatio, "%") : "".concat(height / width * 100, "%"),
        position: "relative"
      };

      if (visualContentType === "audio-player") {
        delete style.paddingTop;
        Object.assign(style, {
          height: 100,
          paddingTop: 0,
          background: "linear-gradient(315deg, ".concat(visualDarkMode ? "#2f3237 1%, #5e5e5e 100%" : "hsla(0, 0%, 89%, 1) 1%, hsla(0, 0%, 97%, 1) 100%", ")")
        });
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-hero-wrapper",
        style: style
      };
    }
  }, {
    key: "aspectRatioBackgroundWrapper",
    value: function aspectRatioBackgroundWrapper(_ref2) {
      var antiAdBlocker = _ref2.customCss.antiAdBlocker,
          visualContentType = _ref2.blocker.visualContentType;
      var style = {
        width: "100%",
        position: "absolute",
        inset: 0
      };

      if (visualContentType === "audio-player") {
        Object.assign(style, {
          width: 100,
          overflow: "hidden"
        });
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-hero-bg-wrapper",
        style: style
      };
    }
  }, {
    key: "aspectRatioBackground",
    value: function aspectRatioBackground(_ref3) {
      var antiAdBlocker = _ref3.customCss.antiAdBlocker,
          _ref3$blocker = _ref3.blocker,
          visualBlur = _ref3$blocker.visualBlur,
          url = _ref3$blocker.visualThumbnail.url;
      var style = {
        background: "url('".concat(url, "') no-repeat center center"),
        backgroundSize: "cover",
        width: "100%",
        position: "absolute",
        inset: 0,
        filter: visualBlur > 0 ? "blur(".concat(visualBlur, "px)") : undefined
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-hero-bg",
        style: style
      };
    }
  }, {
    key: "aspectRatioContainer",
    value: function aspectRatioContainer(_ref4) {
      var _ref4$blocker = _ref4.blocker,
          visualContentType = _ref4$blocker.visualContentType,
          _ref4$blocker$visualT = _ref4$blocker.visualThumbnail,
          hide = _ref4$blocker$visualT.hide,
          _ref4$blocker$visualT2 = _ref4$blocker$visualT.titleType,
          titleType = _ref4$blocker$visualT2 === void 0 ? "top" : _ref4$blocker$visualT2,
          antiAdBlocker = _ref4.customCss.antiAdBlocker;
      var style = {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: (hide === null || hide === void 0 ? void 0 : hide.indexOf("overlay")) > -1 ? undefined : "rgb(0 0 0 / 38%)",
        boxShadow: (hide === null || hide === void 0 ? void 0 : hide.indexOf("title")) > -1 || titleType === "center" ? undefined : "inset 0 115px 60px -60px rgb(0 0 0 / 77%)"
      };

      if (["audio-player"].indexOf(visualContentType) > -1) {
        delete style.boxShadow;
        delete style.background;
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-hero-container",
        style: style
      };
    }
  }, {
    key: "aspectRatioWholeClickable",
    value: function aspectRatioWholeClickable(_ref5) {
      var antiAdBlocker = _ref5.customCss.antiAdBlocker;
      var style = {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-hero-whole-clickable",
        style: style
      };
    }
  }, {
    key: "playButtonWrapper",
    value: function playButtonWrapper(_ref6, isHover) {
      var _ref6$blocker = _ref6.blocker,
          presetId = _ref6$blocker.presetId,
          visualContentType = _ref6$blocker.visualContentType,
          visualDarkMode = _ref6$blocker.visualDarkMode,
          acceptAllBg = _ref6.bodyDesign.acceptAllBg,
          antiAdBlocker = _ref6.customCss.antiAdBlocker;
      var isVimeo = presetId === "vimeo" && visualContentType === "video-player";

      var _hexToRgb = hexToRgb(acceptAllBg),
          r = _hexToRgb.r,
          g = _hexToRgb.g,
          b = _hexToRgb.b;

      var style = {
        cursor: "pointer",
        background: isVimeo ? "rgb(0 0 0 / 70%)" : "rgb(".concat(r, " ").concat(g, " ").concat(b, ")"),
        padding: "15px 30px",
        borderRadius: 5,
        zIndex: 9
      };

      if (visualContentType === "audio-player") {
        Object.assign(style, {
          position: "absolute",
          left: 120,
          top: 49,
          padding: "10px 10px 10px 13px",
          borderRadius: 99
        });

        if (visualDarkMode) {
          Object.assign(style, {
            background: "#111213"
          });
        }
      }

      if (isHover) {
        Object.assign(style, {
          background: isHover ? "rgb(26 183 234 / 100%)" : ""
        });
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-hero-play-wrapper",
        style: style
      };
    }
  }, {
    key: "playButton",
    value: function playButton(_ref7, isHover) {
      var visualContentType = _ref7.blocker.visualContentType,
          antiAdBlocker = _ref7.customCss.antiAdBlocker;
      var scalingFactor = visualContentType === "audio-player" ? 0.2 : 0.3;
      var style = {
        border: 0,
        background: "transparent",
        boxSizing: "border-box",
        width: 0,
        height: 60 * scalingFactor,
        borderColor: "transparent transparent transparent rgb(255 255 255 / ".concat(isHover ? 100 : 94, "%)"),
        transition: "100ms all ease",
        cursor: "pointer",
        borderStyle: "solid",
        borderWidth: "".concat(40 * scalingFactor, "px 0 ").concat(40 * scalingFactor, "px ").concat(60 * scalingFactor, "px")
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-hero-play",
        style: style
      };
    }
  }, {
    key: "title",
    value: function title(_ref8) {
      var _ref8$blocker = _ref8.blocker,
          presetId = _ref8$blocker.presetId,
          visualContentType = _ref8$blocker.visualContentType,
          visualDarkMode = _ref8$blocker.visualDarkMode,
          _ref8$blocker$visualT = _ref8$blocker.visualThumbnail.titleType,
          titleType = _ref8$blocker$visualT === void 0 ? "top" : _ref8$blocker$visualT,
          antiAdBlocker = _ref8.customCss.antiAdBlocker;
      var style = {
        position: "absolute",
        padding: "5px 10px",
        overflow: "hidden",
        maxWidth: "calc(100% - 140px)",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        color: "white",
        textShadow: "1px 1px 1px black",
        fontSize: 15,
        top: 10,
        left: 10
      };

      if (presetId === "vimeo" && visualContentType === "video-player" && titleType === "top") {
        Object.assign(style, {
          top: 20,
          left: 20,
          background: "#00000059",
          fontWeight: "bold",
          color: "rgb(0, 173, 239)",
          textShadow: undefined
        });
      } else if (visualContentType === "audio-player") {
        Object.assign(style, {
          left: 110,
          color: visualDarkMode ? "white" : "black",
          textShadow: "1px 1px 1px ".concat(visualDarkMode ? "black" : "white")
        });
      } else if (titleType === "center") {
        Object.assign(style, {
          position: undefined,
          background: "#0000007d",
          overflow: undefined,
          textOverflow: undefined,
          whiteSpace: undefined,
          textAlign: "center",
          marginBottom: 15
        });
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-hero-title",
        style: style
      };
    }
  }, {
    key: "defaultBlockerContainer",
    value: function defaultBlockerContainer(_ref9, isVisible, rect) {
      var antiAdBlocker = _ref9.customCss.antiAdBlocker;
      var style = {
        position: "absolute",
        padding: window.innerWidth < BANNER_SCALING_WHEN_WINDOW_WIDTH_LOWER ? "20px 5px" : "20px 30px",
        zIndex: ZINDEX,
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "all" : "none",
        display: "flex",
        transition: "opacity 300ms"
      }; // Calculate position inside our Portal relative to the entire document
      // See also https://stackoverflow.com/a/36520974/5506547

      if (rect) {
        var top = rect.top,
            left = rect.left,
            width = rect.width;
        var _window = window,
            scrollY = _window.scrollY,
            scrollX = _window.scrollX;
        Object.assign(style, {
          top: top + scrollY,
          left: left + scrollX,
          width: width
        });
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-db-container",
        style: style
      };
    }
  }, {
    key: "defaultBlockerOverlay",
    value: function defaultBlockerOverlay(_ref10, isVisible) {
      var antiAdBlocker = _ref10.customCss.antiAdBlocker;
      var style = {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: ZINDEX,
        background: "#000000cf",
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "all" : "none",
        transition: "opacity 300ms"
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-db-overlay",
        style: style
      };
    }
  }]);

  return BlockerHeroInlineStyles;
}();

export { BlockerHeroInlineStyles };